import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Context from '../../context/Context'

const InvoiceDetails = ({ invoiceLines }) => {
  const context = useContext(Context)

  return (
    <div className="row mt-5 col-10 offset-1 col-sm-8 offset-sm-2">
      <table className="table table-sm">
        <tbody>
          {invoiceLines.map((invoiceLine, index) => (
            (
              parseInt(invoiceLine.out_invoice_item_vat_id) === 2 &&
              parseInt(invoiceLine.out_invoice_item_id) !== 1000 &&
              (parseInt(invoiceLine.out_invoice_item_id) !== 1 || (parseInt(invoiceLine.out_invoice_item_id) === 1 && parseInt(invoiceLine.amount) > 0)) &&
              (parseInt(invoiceLine.out_invoice_item_id) !== 4 || (parseInt(invoiceLine.out_invoice_item_id) === 4 && parseInt(invoiceLine.amount) > 0))
            )
              ? <tr key={index}>
                <td>
                  <span className="paragraph-bold-12">{invoiceLine.product}</span>
                </td>
                <td className="text-end">
                  <span className="paragraph-regular-12">{invoiceLine.amount} {invoiceLine.price_unit}</span>
                </td>
              </tr>
              : null
          ))}
        </tbody>
        <tfoot>
          <tr className="summary-row-background">
            <td>
              <span className="paragraph-bold-12">Summa</span>
            </td>
            <td colSpan="2" className="text-end">
              <span className="paragraph-bold-12">{context.invoice.total_amount} kr</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

InvoiceDetails.propTypes = {
  invoiceLines: PropTypes.array.isRequired
}

export default InvoiceDetails
